import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import DirectBookingList from '../../../components/Booking/DirectBookingList/DirectBookingList';
import s from './DirectBookings.css';
import messages from '../../../locale/messages';

export class DirectBookings extends Component {
    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div className={s.root}>
                <div className={s.container}>
                    <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
                        {formatMessage(messages.directBookingMenu)}
                    </div>
                    <div className={s.paddingRoutesSection}>
                        <DirectBookingList />
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withStyles(s),
)(DirectBookings);
